import Vue from "vue";
import VueRouter from "vue-router";
// 日志管理
import log from "./log";
// 进销存资料
import inventoryData from "./inventoryData";
// 客户管理
import customerManagment from "./customerManagment";
import userCode from "@/util/allCode.js";
Vue.use(VueRouter);
let SSOPATH;
let redirectPath;
if (sessionStorage.getItem("navCode")) {
  SSOPATH = JSON.parse(sessionStorage.getItem("navCode"));
  console.log(SSOPATH[0]);
  userCode.map((item) => {
    if (item.code == SSOPATH[0]) {
      redirectPath = item.path;
    }
  });
}
let routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../page/index.vue"),
    redirect: redirectPath,
    children: [
      // 角色管理
      {
        path: "/roleManage",
        name: "roleManage",
        component: () => import("../views/perManage/role.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 角色权限管理
      {
        path: "/rolePer",
        name: "rolePer",
        component: () => import("../views/perManage/rolePer.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 财务管理
      {
        path: "/financial",
        name: "financial",
        component: () => import("../views/financial/index.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存报表 硬件产品销售一览表
      {
        path: "/sale",
        name: "sale",
        component: () => import("../views/reportTable/sale.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存管理-物料管理
      {
        path: "/material",
        name: "material",
        component: () => import("../views/purchaseSales/material.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存管理-库存管理
      {
        path: "/stock",
        name: "stock",
        component: () => import("../views/purchaseSales/stock.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 产成品管理
      {
        path: "/stock/finished",
        name: "finished",
        component: () => import("../views/purchaseSales/finished.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      //确认入库
      {
        path: "/stock/firmGoods",
        name: "firmGoods",
        component: () => import("../views/purchaseSales/firmGoods.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 设备入库
      {
        path: "/stock/warehousing",
        name: "warehousing",
        component: () => import("../views/Warehousing/index.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 设备出库
      {
        path: "/stock/outhousing",
        name: "warehousing",
        component: () => import("../views/equipmentWarehouse/index.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
       // 物料入库
       {
        path: "/material/materhouse",
        name: "materhouse",
        component: () => import("../views/Warehousing/materhouse.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 物料出库
      {
        path: "/material/materOut",
        name: "materOut",
        component: () => import("../views/equipmentWarehouse/materOut.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存管理-售后管理
      {
        path: "/afterSales",
        name: "afterSales",
        component: () => import("../views/purchaseSales/afterSales.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存管理-退货管理
      {
        path: "/returnGoods",
        name: "returnGoods",
        component: () => import("../views/purchaseSales/returnGoods.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存报表 产品定价
      {
        path: "/price",
        name: "price",
        component: () => import("../views/reportTable/price.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存报表 入库明细表
      {
        path: "/detailed",
        name: "detailed",
        component: () => import("../views/reportTable/detailed.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存报表 入库汇总表
      {
        path: "/summary",
        name: "summary",
        component: () => import("../views/reportTable/summary.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存报表 销售明细表
      {
        path: "/salesDetails",
        name: "salesDetails",
        component: () => import("../views/reportTable/salesDetails.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存报表 销售汇总表
      {
        path: "/salesSummary",
        name: "salesSummary",
        component: () => import("../views/reportTable/salesSummary.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存报表 库存报表
      {
        path: "/stockForm",
        name: "stockForm",
        component: () => import("../views/reportTable/stockForm.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存报表 库存盘点表
      {
        path: "/inventoryCheck",
        name: "inventoryCheck",
        component: () => import("../views/reportTable/inventoryCheck.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存报表 进销存明细表
      {
        path: "/saleDetails",
        name: "saleDetails",
        component: () => import("../views/reportTable/saleDetails.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 进销存报表 进销存汇总表
      {
        path: "/PurSalessummary",
        name: "PurSalessummary",
        component: () => import("../views/reportTable/PurSalessummary.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      //订单管理-商城订单
      {
        path: "/shopOrder",
        name: "shopOrder",
        component: () => import("@/views/orderManagement/shopMallOrder.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      //订单管理-订单详情
      {
        path: "/orderDeatile",
        name: "orderDeatile",
        component: () => import("@/views/orderManagement/orderDeatile.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // //鸿利及绩效-vip
      // {
      //   path: "/vip",
      //   name: "vip",
      //   component: () => import("@/views/hongliAndPerformance/vip.vue"),
      //   meta: {
      //     noNeedCheckLogin: true,
      //   },
      // },
      //鸿利及绩效-鸿利及绩效管理
      {
        path: "/hongli",
        name: "hongli",
        component: () => import("@/views/hongliAndPerformance/hongli.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      //鸿利及绩效-充值
      // {
      //   path: "/hongliRecharge",
      //   name: "hongliRecharge",
      //   component: () => import("@/views/hongliAndPerformance/hongliRecharge.vue"),
      //   meta: {
      //     noNeedCheckLogin: true,
      //   },
      // },
      // //鸿利及绩效-星云
      // {
      //   path: "/achievements",
      //   name: "achievements",
      //   component: () => import("@/views/hongliAndPerformance/achievements.vue"),
      //   meta: {
      //     noNeedCheckLogin: true,
      //   },
      // },
      // 日志管理
      ...log,
      // 进销存资料
      ...inventoryData,
      // 客户管理
      ...customerManagment,
    ],
  },
  // 无权限
  {
    path: "/noper",
    name: "noper",
    meta: {
      noNeedCheckLogin: true,
      a: true,
    },
    component: () => import("../views/405.vue"),
  },
];

const createRouter = () =>
  new VueRouter({
    mode: "hash", // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
